
module.directive('dropdownMenu', function($document) {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/dropdownMenu',
        scope: {buttonText: '@label'},
        transclude: true,
        link: function(scope, element, attrs) {
            scope.open = false;

            function clickOutside(event) {
                if (!element[0].contains(event.target)) {
                    scope.$apply(closeMenu);
                }
            }

            function openMenu() {
                element.addClass('open');
                scope.open = true;
                $document.bind("click", clickOutside);
            }

            function closeMenu() {
                element.removeClass('open');
                $document.unbind("click", clickOutside);
                scope.open = false;
            }

            element.find('button').bind("click", function() {
                if (element.hasClass('open')) {
                    scope.$apply(closeMenu);
                } else {
                    scope.$apply(openMenu);
                }
            });
        }
    };
});
